<!-- 滑动验证码 -->
<template>
  <div class="slider-verify">
    <van-popup v-model:show="verifyShow">
      <div class="verify-box">
        <slide-verify
          ref="block"
          :slider-text="text"
          :imgs="picArray"
          @again="onFail"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          style="left: 0px"
        ></slide-verify>
      </div>
    </van-popup>
  </div>
</template>
<script>
// 局部注册组件，需要单独引用组件样式
// 只提供局部引用的方式，不再采用插件形式，方便按需加载，减少主包大小
import SlideVerify, { SlideVerifyInstance } from "vue3-slide-verify";
import "vue3-slide-verify/dist/style.css";
export default {
  components: {
    SlideVerify
  },
  data() {
    return {
      verifyShow: false, // 弹窗显示
      isVerifyShowSucess: false, // 是否校验通过
      picArray: [
        require('@/assets/imgs/sliderVerify/v1.jpg'),
        require('@/assets/imgs/sliderVerify/v2.jpg'),
        require('@/assets/imgs/sliderVerify/v3.jpg'),
        require('@/assets/imgs/sliderVerify/v4.jpg'),
        require('@/assets/imgs/sliderVerify/v5.jpg'),
        require('@/assets/imgs/sliderVerify/v6.jpg'),
        require('@/assets/imgs/sliderVerify/v7.jpg'),
        require('@/assets/imgs/sliderVerify/v8.jpg')
      ],
      accuracy: 1,
      text: '滑块校验',
    }
  },
  created() { },
  mounted() { },
  methods: {
    onSuccess() {
      //往父级传递验证通过的函数
      this.$toast.success('校验成功')
      setTimeout(() => {
        this.isVerifyShowSucess = true
        this.verifyShow = false
        this.$emit('onSuccess')
      }, 2000)
    },
    onReset() {
      //重置图片验证组件
      // console.log(this.$refs);
      // console.log(this.$refs.block);
      this.$refs.block.refresh();
    },
    onFail() {
      this.$toast.fail('校验错误！')
    },
    onRefresh() { },
    handleClick() {
      this.$refs.block.refresh();
    }
  },
}
</script>
<style lang="less">
.slider-verify {
  // 滑块验证
  .verify-box {
    background: #fff;
    padding: 30px 20px;
  }

  .slide-verify-slider {
    margin-top: 0 !important;
    font-size: 14px;
  }
}
</style>
